import styled, { css } from 'styled-components'

import { Cover, Reset, TransitionPrimary } from '@/lib/mixins'

export const TopBarWrapper = styled.div`
  position: relative;
  display: flex;
  height: ${props => props.theme.size.topBar};
  justify-content: flex-end;
  background-color: ${props => props.theme.color.primary};
  color: ${props => props.theme.color.inverted};

  ${props =>
    props.theme.contrastMode &&
    !props.theme.accessibilityMode &&
    css`
      border-bottom: 1px solid ${props.theme.color.lineInverted};
    `};

  ${props =>
    props.theme.contrastMode &&
    props.theme.accessibilityMode &&
    css`
      border-top: 1px solid ${props.theme.color.lineInverted};
    `};
  &:after {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 1px;
    background-color: currentColor;
    opacity: 0.175;
  }
`

export const TopBarTool = styled.div`
  position: relative;
`

export const TopBarClock = styled.div`
  ${TransitionPrimary('color')}
  margin-right: auto;
  flex: 0 0 20%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  time {
    line-height: 1.15;
    &:nth-child(1) {
      font-size: 2.4rem;
      font-weight: 600;
    }
    &:nth-child(2) {
    }
  }
`

interface TopBarBtnProps {
  variant?: 'light' | 'dark' | 'white'
  ref?: React.Ref<HTMLButtonElement>
  onClick?: React.MouseEventHandler<HTMLButtonElement>
}

export const TopBarBtn = styled.button<TopBarBtnProps>`
  ${Reset('button')}
  position: relative;
  height: ${props => props.theme.size.topBar};
  width: 5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.color.inverted};
  gap: 0.35rem;
  &:before {
    ${Cover()}
    background-color: rgba(0, 0, 0, 0.15);
  }

  > * {
    position: relative;
  }

  svg {
    fill: currentColor;
    width: 1.25rem;
    height: 1.25rem;
  }

  span {
    text-transform: uppercase;
    font-size: 0.8rem;
    font-weight: 600;
  }

  img {
    width: 1.25rem;
    height: 1.25rem;
  }

  ${props =>
    props.variant === 'light' &&
    css`
      &:before {
        background-color: rgba(255, 255, 255, 0.08);
      }
    `};

  ${props =>
    props.variant === 'white' &&
    css`
      color: ${props => props.theme.color.primary};
      &:before {
        background-color: ${props => props.theme.color.inverted};
      }
      svg {
        width: 1.5rem;
        height: 1.5rem;
      }
    `};
`

export const TopBarUtils = styled.div`
  flex: 0 0 40%;

  &:first-child {
    ${props =>
      props.theme.contrastMode &&
      css`
        ${TopBarBtn} {
          border-right: 1px solid ${props => props.theme.color.line};
        }
      `};
  }

  &:last-child {
    display: flex;
    justify-content: flex-end;

    ${props =>
      props.theme.contrastMode &&
      css`
        ${TopBarBtn} {
          border-left: 1px solid ${props => props.theme.color.line};
        }
      `};
  }
`

export const TopBarOption = styled.button`
  ${Reset('button')}
  position: relative;
  width: 100%;
  padding: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
`

interface TopBarDropdownProps {
  $show?: boolean
  dir?: 'left' | 'right'
}

export const TopBarDropdownTrigger = styled(TopBarBtn)``

export const TopBarDropdownWrapper = styled.div<TopBarDropdownProps>`
  position: absolute;
  top: 100%;
  min-width: 12rem;
  color: ${props => props.theme.color.global};
  padding: 0.25rem;
  visibility: hidden;
  opacity: 0;
  ${TransitionPrimary('visibility, opacity')};
  background-color: ${props => props.theme.color.body};
  box-shadow: 0 0 2rem rgba(0, 0, 0, 0.1);

  ${props =>
    props.theme.accessibilityMode &&
    css`
      bottom: 100%;
      top: auto;
    `};

  ${props =>
    props.theme.contrastMode &&
    css`
      border: 1px solid ${props.theme.color.line};
      margin-top: -1px;
    `};

  ${props =>
    props.$show &&
    css`
      visibility: visible;
      opacity: 1;
    `};

  ${props =>
    props.dir === 'left' &&
    css`
      left: 0;
    `};

  ${props =>
    props.dir === 'right' &&
    css`
      right: 0;
    `};
`
interface FontTogglerProps {
  size?: 'md' | 'lg' | 'xl'
  $active: boolean
}

export const FontSizes = styled.div`
  display: flex;
  justify-content: center;
  padding: 0.5rem;
`

export const FontToggler = styled.button<FontTogglerProps>`
  ${Reset('button')}
  font-size: 1rem;
  width: 4rem;
  height: 4rem;
  font-weight: 500;
  border: 1px solid ${props => props.theme.color.line};

  ${props =>
    props.$active &&
    !props.theme.contrastMode &&
    css`
      background-color: ${props.theme.color.primary};
      color: ${props.theme.color.inverted};
    `};

  ${props =>
    props.$active &&
    props.theme.contrastMode &&
    css`
      background-color: ${props.theme.color.inverted};
      color: ${props.theme.color.dark};
    `};

  &:not(:last-child) {
    margin-right: 0.5rem;
  }

  &:after {
    content: 'Aa';
  }

  ${props =>
    props.size === 'lg' &&
    css`
      font-size: 28px;
    `};

  ${props =>
    props.size === 'xl' &&
    css`
      font-size: 36px;
    `};
`
